import { default as Navbar } from './Navbar';

export default Navbar;
